import parse, { domToReact, Element, HTMLReactParserOptions } from 'html-react-parser'
import EnhancedLink from './EnhancedLink'
import { Box } from '@ds/components'

type EnhancedCopyProps = {
    enhancedCopy: string | null | undefined
}

const parseOptions: HTMLReactParserOptions = {
    replace: (domNode) => {
        if (
            domNode instanceof Element &&
            domNode.name === 'a'
            // && !['p', 'span', 'div'].includes(domNode.tagName.toLowerCase())
        ) {
            const { href, ...attribs } = domNode.attribs
            return (
                <EnhancedLink to={href || '#'} {...attribs}>
                    {domToReact(domNode.children, parseOptions)}
                </EnhancedLink>
            )

            return null
        }
    },
}

// @TODO this needs extensive testing to ensure no regressions
const EnhancedCopy = ({ enhancedCopy }: EnhancedCopyProps) => {
    if (!enhancedCopy) {
        return null
    }

    return <Box sx={{ position: 'relative', color: '#6F6F6F' }}>{parse(enhancedCopy, parseOptions)}</Box>
}

export default EnhancedCopy
